import styled from "styled-components";
import { breakpoints } from "definitions";
import { animated } from "react-spring";

// Los pasos se apilan en la misma celda de grilla en vez de sacar al que se va
// con `position: absolute`. Ese `position` viajaba dentro del spring y, al no
// ser animable, la transición nunca terminaba: el paso viejo quedaba montado
// para siempre y el nuevo se congelaba a media opacidad.
export const StepViewport = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  justify-items: center;
`;

export const Step = styled(animated.div)`
  grid-area: 1 / 1;
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;

  /* El paso que se está yendo no debe robar clicks al que entra. */
  pointer-events: ${({ $leaving }) => ($leaving ? "none" : "auto")};
`;

// Ancho y aire de los pasos de selección (temáticas y premios). El formulario
// y el mensaje final traen su propio contenedor, por eso no lo usan.
export const StepContent = styled.div`
  width: 100%;
  max-width: 124.5rem;
  padding: 3rem 2.5rem;

  ${breakpoints.tablet} {
    padding: 2rem 1.6rem;
  }
`;
